import { Avatar, Hidden, ListItemText, Menu, MenuItem, Typography } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { StoreSubscribe } from '../../../providers/global-store-provider';
import { RouteHistory } from '../../../providers/route-provider';
import { getAdminRoles, inIframe } from '../libs/helpers';

export default class AccountMenu extends React.Component {
  state = {
    anchorEl: null,
  };
  static defaultProps = {
    noName: false,
  }
  /*
  -----------------------------------------------------------------------
  API Functions
  -----------------------------------------------------------------------
  */

  /*
  -----------------------------------------------------------------------
  RENDER Functions
  -----------------------------------------------------------------------
  */
  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    if (inIframe())
      return <div />
    const { anchorEl } = this.state;
    let adminAlreadyRendered = false;
    return (
      <div>
        <StoreSubscribe>
          {store => [
            <div key={1} style={{ display: 'flex', alignItems: 'center' }} onClick={this.handleClick} aria-owns={anchorEl ? 'account-menu' : undefined} aria-haspopup="true">
              <Avatar className="cursor-pointer"><img src={store.state.auth.user.image_url} style={{ width: '100%' }} /></Avatar>
              {!this.props.noName
                && <Hidden smDown>
                  <Typography style={{ marginLeft: '10px' }} className='cursor-pointer color-invert' component="h4">{store.state.auth.user.first_name}</Typography>
                </Hidden>
              }
            </div>,
            <Menu key={2}
              id="account-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
            >
              {store.state.auth.user.roles && store.state.auth.user.roles.length > 0 && store.state.auth.user.roles.map((item, key) => {
                let itemName = item.charAt(0).toUpperCase() + item.slice(1);
                if (getAdminRoles().indexOf(item) !== -1) {
                  if (adminAlreadyRendered)
                    return;
                  adminAlreadyRendered = true;
                  itemName = 'Admin';
                }
                if (item === store.state.auth.user.role || ['fund-owner', 'mentor', 'mentee','institution-manager'].indexOf(item) !== -1) return;

                return (<MenuItem key={key} onClick={() => { store.auth.setRole(item); RouteHistory.push('/'); }}>
                  <ListItemText primary={'Switch to ' + itemName} />
                </MenuItem>)
              })}
              <MenuItem key={1000} component={Link} to={(store.state.auth.user.role === 'admin' ? '/admin' : '')}>
                <ListItemText primary='Dashboard' />
              </MenuItem>
              <MenuItem key={1001} component={Link} to={(store.state.auth.user.role === 'admin' ? '/admin' : '') + '/profile'}>
                <ListItemText primary='Profile' />
              </MenuItem>
              <MenuItem key={1002} component={Link} to={(store.state.auth.user.role === 'admin' ? '/admin' : '') + '/help'}>
                <ListItemText primary='Help & Support' />
              </MenuItem>
              <MenuItem key={1003} component={Link} to='/logout'>
                <ListItemText primary='Logout' />
              </MenuItem>
            </Menu>
          ]
          }
        </StoreSubscribe>
      </div>

    );
  }
}
